import { createI18n } from 'vue-i18n';
import axios from 'axios';

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'en', // Default language
  fallbackLocale: 'en', // Fallback if translation missing
  messages: {
    en: {} // Start with empty, will be loaded dynamically
  }
});

// Helper function to load translations from API
export async function loadLanguageAsync(languageCode) {
  console.log(`📖 loadLanguageAsync called for: ${languageCode}`);

  // Check if already loaded
  const alreadyLoaded = i18n.global.availableLocales.includes(languageCode) &&
      Object.keys(i18n.global.messages[languageCode] || {}).length > 0;

  if (alreadyLoaded) {
    console.log(`✓ Language ${languageCode} already loaded, just switching locale`);
    console.log(`Current locale before: ${i18n.global.locale.value}`);
    i18n.global.locale.value = languageCode;
    console.log(`Current locale after: ${i18n.global.locale.value}`);
    return languageCode;
  }

  try {
    // Fetch translations from API
    console.log(`🌐 Fetching translations from: /storesafe/api/translations/${languageCode}`);
    const response = await axios.get(`/storesafe/api/translations/${languageCode}`, {
      withCredentials: true
    });
    console.log(`📦 API Response:`, response.data);

    // The API returns { language: {...}, translations: {...} }
    // Extract just the translations object
    const messages = response.data.translations || response.data;
    console.log(`📝 Extracted ${Object.keys(messages).length} translation keys`);
    console.log(`Sample keys:`, Object.keys(messages).slice(0, 5));

    // Set locale messages
    i18n.global.setLocaleMessage(languageCode, messages);
    console.log(`✓ Set locale messages for ${languageCode}`);

    // Set as current locale
    console.log(`Current locale before: ${i18n.global.locale.value}`);
    i18n.global.locale.value = languageCode;
    console.log(`Current locale after: ${i18n.global.locale.value}`);

    console.log(`✅ Loaded ${Object.keys(messages).length} translations for ${languageCode}`);

    return languageCode;
  } catch (error) {
    console.error(`❌ Error loading language ${languageCode}:`, error);

    // Fallback to English on error
    if (languageCode !== 'en') {
      i18n.global.locale.value = 'en';
    }

    throw error;
  }
}

export default i18n;
